<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOGARANTIA.LBL_RESPALDO' | translate}}">

    <p-fieldset legend="{{ 'PRODUCTOGARANTIA.LBL_TIPOGARANTIA' | translate }}" class="margin-botton-fieldset">
      <form [formGroup]="formularioGarantia" (ngSubmit)="onSubmitGarantia()" novalidate id="fFormularioRespaldos" name="nomFormularioRespaldos" class="col-12">
        <div class="row">
          <div class="grid form-group align-items-center">
          <div class="col-12 md:col-4 lg:col-4 pt-0">
            <div class="div-form">
              <label>* {{ 'PRODUCTOGARANTIA.LBL_TIPOVALOR' | translate }}</label>
              <p-dropdown disableTab  id="idTipoValor" name="valor" [options]="lisTiposValores"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
                           formControlName="idTipoValor"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submittedGarantia && r.idTipoValor.invalid">
                {{ 'PRODUCTOGARANTIA.LBL_TIPOVALOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
              </div>
            </div>
          </div>
          <div class="col-12 md:col-4 lg:col-4">
            <div *ngIf="!guardandoGarantia">
              <button class="p-button-datatables" icon="fa fa-plus" label="{{(producto.idTipoValor ? 'BTN_ACTUALIZAR' : 'BTN_GUARDAR') | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardandoGarantia">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
        </div>
      </form>
    </p-fieldset>
    <p-fieldset legend="{{ 'PRODUCTOGARANTIA.LBL_CONFORMACIONRESPALDOS' | translate }}">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioGarantia" name="nomFormularioGarantia" style="width: 100%">
      <div class="row">
        <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOGARANTIA.LBL_PERFIL' | translate }}</label>
            <p-dropdown disableTab  id="idRiesgo" name="nomRiesgo" [options]="lisPerfiles"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idPerfilRiesgo"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPerfilRiesgo.invalid">
              {{ 'PRODUCTOGARANTIA.LBL_PERFIL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOGARANTIA.LBL_NIVELAPRUEBA' | translate }}</label>
            <p-dropdown disableTab  id="idNivelAprueba" name="nomNivelAprueba" [options]="lisNivelAprueba" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" (onChange)="cargarNivelExcepcion($event.value)"
                         formControlName="idNivelAprueba"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNivelAprueba.invalid">
              {{ 'PRODUCTOGARANTIA.LBL_NIVELAPRUEBA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOGARANTIA.LBL_NIVELEXCEPCION' | translate }}</label>
            <p-dropdown disableTab  id="idNivelExcepcion" name="nomNivelExcepcion" [options]="lisNivelExcepcion"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
                         formControlName="idNivelExcepcion"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idNivelExcepcion.invalid">
              {{ 'PRODUCTOGARANTIA.LBL_NIVELEXCEPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      </div>

      <div class="row">
        <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOGARANTIA.LBL_MONTOMINIMO' | translate }} ({{ 'LBL_SMLV' | translate }})</label>
            <input type="text" pInputText id="idMontoMinimo"
                   name="nomMontoMinimo"
                   autocomplete="off"
                   formControlName="montoMinimo" numero-decimal-reactive [decimales]="6" [entero]="7" [minimo]="0"
                   [maxlength]="14"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMinimo.invalid">
              {{ 'PRODUCTOGARANTIA.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOGARANTIA.LBL_MONTOMAXIMO' | translate }} ({{ 'LBL_SMLV' | translate }})</label>
            <input type="text" pInputText id="idMontoMaximo"
                   name="nomMontoMaximo"
                   autocomplete="off"
                   formControlName="montoMaximo" numero-decimal-reactive [decimales]="6" [minimo]="0" [entero]="7"
                   [maxlength]="14"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximo.invalid">
              {{ 'PRODUCTOGARANTIA.LBL_MONTOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="ranIncorrecto">
              {{ 'LBL_RANGOINVALIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-4">
          <div class="div-form">
            <label>* {{ 'PRODUCTOGARANTIA.LBL_CODEUDOR' | translate }}</label>
            <input type="text" pInputText id="idCodeudor"
                   name="nomCodeudor"
                   autocomplete="off"
                   formControlName="minimoCodeudores" numero-entero-reactive
                   [maxlength]="2"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.minimoCodeudores.invalid">
              {{ 'PRODUCTOGARANTIA.LBL_CODEUDOR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!guardando">
            <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>
    </p-fieldset>
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
               (input)="proGarantia.filterGlobal($event.target.value, 'contains')">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table [columns]="columnas" [loading]="guardando" #proGarantia
                 [value]="lisProductosGarantias" selectionMode="single" dataKey="idProductoGarantia"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.perfilRiesgo}}</td>
              <td>{{row.rangoMonto}}</td>
              <td>{{row.minimoCodeudores}}</td>
              <td>{{row.nivelAprueba}}</td>
              <td>{{row.nivelExcepcion}}</td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                          title="{{'BTN_INHABILITAR' | translate}}" pButton
                          (click)="inhabilitar(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-panel>
</div>


<p-confirmDialog #cd key="garantias">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
